module.exports = __webpack_public_path__ + "static/media/roomsB.f77a28df.png";